import React from "react";
import { SectionLabel } from "./ui";

const INDUSTRIES = [
  { code: "CG", title: "Consumer Goods", pain: "Trade promos leak, AR ages, distributors go dark.", win: "Agents that orchestrate route-to-market, credit and collections end-to-end.", proof: { metric: "+$284K", label: "recovered / wk per distributor" } },
  { code: "EL", title: "Electronics",   pain: "Supplier risk, channel mismatch, warranty drag on margin.", win: "BOM optimization, multi-tier supplier intelligence, after-sales auto-triage.", proof: { metric: "−38%", label: "warranty handling cost" } },
  { code: "HC", title: "Healthcare",    pain: "Claim denials, no-shows, fragmented care coordination.", win: "Prior-auth, denial-prevention and patient-flow agents — HIPAA-aligned.", proof: { metric: "94%", label: "first-pass claim approval" } },
  { code: "HT", title: "Hospitality",   pain: "Empty rooms, slow service recovery, lost loyalty value.", win: "Revenue, concierge and housekeeping agents that lift RevPAR and CSAT.", proof: { metric: "+11pts", label: "RevPAR lift in 90 days" } },
  { code: "FM", title: "Film & Media",  pain: "Production overruns, opaque distribution, audience misreads.", win: "Schedule, rights and audience-analytics agents that compress timelines.", proof: { metric: "−22%", label: "production overruns" } },
  { code: "MF", title: "Manufacturing & Industrial", pain: "Procurement chaos, quality drift, logistics surprises.", win: "Plant ops, supplier collaboration and logistics agents — 24/7.", proof: { metric: "9.2×", label: "throughput on procurement ops" } },
];

export default function IndustriesSection() {
  return (
    <section id="industries" className="relative py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid items-end gap-8 lg:grid-cols-[1fr,auto]">
          <div className="max-w-3xl">
            <SectionLabel>Industry depth</SectionLabel>
            <h2 className="mt-5 text-[36px] leading-[1.05] tracking-tight sm:text-[44px] lg:text-[52px]">
              <span className="text-white">Generic AI ignores the messy bits.</span>{" "}
              <span className="font-display italic grad-text">We start there.</span>
            </h2>
          </div>
          <a href="#book" className="text-cyan-300 hover:text-white text-[13.5px] font-mono tracking-wider uppercase inline-flex items-center gap-2">
            Don&rsquo;t see yours? Talk to us →
          </a>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-px overflow-hidden rounded-3xl border border-white/[0.06] bg-white/[0.04] md:grid-cols-2 lg:grid-cols-3">
          {INDUSTRIES.map(ind => (
            <div key={ind.code} className="group relative bg-[#070d24] p-7 hover:bg-[#0a1230]">
              <div className="flex items-center justify-between">
                <span className="font-mono text-[10px] uppercase tracking-[0.28em] text-white/35">{ind.code} / vertical</span>
                <span className="font-mono text-[10px] text-cyan-300/70">live deployments</span>
              </div>
              <h3 className="mt-5 text-[22px] font-semibold tracking-tight text-white">{ind.title}</h3>
              <p className="mt-3 text-[13.5px] text-white/55">{ind.pain}</p>
              <p className="mt-2 text-[13.5px] text-white/85"><span className="text-cyan-300">→</span> {ind.win}</p>
              <div className="mt-6 flex items-end justify-between border-t border-white/[0.06] pt-4">
                <div>
                  <div className="text-[26px] font-semibold tracking-tight nums grad-text">{ind.proof.metric}</div>
                  <div className="text-[11px] text-white/45 mt-0.5">{ind.proof.label}</div>
                </div>
                <a href="#book" className="font-mono text-[10.5px] uppercase tracking-[0.18em] text-white/40 hover:text-cyan-300">explore →</a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
